import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

import { environment as ENV } from '@environment';
import {
  PriceDetailCardDiscount, PriceDetailCardPrice, PriceDetailCardSubtitle, PriceDetailCardType
} from '@design-system/components/organisms/price-detail-card/entities/price-detail-card.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-payment-detail-cont',
  templateUrl: './payment-detail-cont.component.html',
  styleUrls: ['./payment-detail-cont.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PaymentDetailContComponent {

  @Input() total: number;
  @Input() currencyCode: string;
  @Input() conversionRate: number;
  @Input() text: string;
  @Input() discount: PriceDetailCardDiscount;
  @Input() subtitles: PriceDetailCardSubtitle[] = [];
  @Input() rows: PriceDetailCardPrice[][] = [];
  @Input() customTitle: string;
  @Input() showInfo: string;

  @Input() isModal = false;
  @Input() isMobile = false;
  @Input() isTooltip = false;
  @Input() showSwipeUp = false;
  @Input() isLoading = false;
  @Input() isUserHistory = false;

  @Output() toggleShowSwipeUp: EventEmitter<Event> = new EventEmitter<Event>();

  public readonly fontSize = TypographyFontSize;
  public readonly fontFamily = TypographyFontFamily;
  public readonly fontColor = TypographyColor;

  constructor() { }

  get priceDetailCardType(): PriceDetailCardType {
    return this.isModal ? PriceDetailCardType.Embedded : PriceDetailCardType.Tooltip;
  }

  get currencyExchangeName(): string {
    return ENV.countryModules?.booking?.exchange_rate?.currency_to_name;
  }

  get applyConversion(): boolean {
    return !!ENV.countryModules?.booking?.exchange_rate?.enabled && !!this.conversionRate;
  }

  get hasTextFare(): boolean {
    return this.isModal && !!this.text;
  }

}
